import { AssetClassPutEvent } from '../event/asset-class-put.event';
const assetClassPutProjections = {
    [AssetClassPutEvent.name]: (event, state) => ({
        ...state,
        ...event.getPayload(),
        deleted: false,
    }),
};
export default assetClassPutProjections;
//# sourceMappingURL=asset-class-put.projection.js.map